import { cn } from '../../lib/cn';
import type { IntegrationRow } from '../../platformadmin/framework';

type Props = { integrations?: IntegrationRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'connected': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'pending': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function IntegrationCenterPanel({ integrations = [] }: Props) {
  return (
    <div className="grid gap-2 grid-cols-2 sm:grid-cols-4">
      {integrations.map((i) => (
        <div key={i.provider} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{i.provider}</p>
          <span className={cn('mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(i.status))}>
            {i.status}
          </span>
          <p className="mt-1 text-xs text-slate-500">Last sync: {i.lastSync}</p>
        </div>
      ))}
    </div>
  );
}
